import { Theme } from '../../theme'
import { PickerStatus } from './assignee-picker.types'

export const getColorForStatus = (
  status: PickerStatus
): keyof Theme['colors'] => {
  switch (status) {
    case 'overdue':
      return 'alert400'
    case 'completed':
      return 'success400'
    default:
      return 'gray600'
  }
}
